<div [class]="config()?.customClasses?.container || 'pkp-list'">
  @if (config()?.blockHeading) {
  <div [class]="config()?.customClasses?.heading || 'pl-4 mb-2'">
    <p class="text-base text-[--basic-color]">{{ config()?.blockHeading | localization }}:</p>
  </div>
  }

  <div [class]="config()?.customClasses?.grid || 'grid grid-cols-2 gap-4 p-4 border-t'">
    <div [class]="config()?.customClasses?.column || 'space-y-4'">
      @for (field of config()?.leftColumn; track field.label) { @if (!isFieldHidden(field)) {
      <div [class]="config()?.customClasses?.fieldContainer || ''">
        @if (!field.customTemplate) {
        <p [class]="config()?.customClasses?.label || 'text-[--description-color] text-sm'">
          {{ field.label | localization }}:
        </p>
        <p [class]="config()?.customClasses?.value || 'font-medium'">
          {{ field | displayInfoField }}
        </p>
        } @else {
        <ng-container
          *ngTemplateOutlet="field.customTemplate!; context: { field: field, value: field.value }"
        ></ng-container>
        }
      </div>
      } }
    </div>
    <div [class]="config()?.customClasses?.column || 'space-y-4'">
      @for (field of config()?.rightColumn; track field.label) { @if (!isFieldHidden(field)) {
      <div [class]="config()?.customClasses?.fieldContainer || ''">
        @if (!field.customTemplate) {
        <p [class]="config()?.customClasses?.label || 'text-[--description-color] text-sm'">
          {{ field.label | localization }}:
        </p>
        <p [class]="config()?.customClasses?.value || 'font-medium'">
          {{ field | displayInfoField }}
        </p>
        } @else {
        <ng-container
          *ngTemplateOutlet="field.customTemplate!; context: { field: field, value: field.value }"
        ></ng-container>
        }
      </div>
      } }
    </div>
  </div>
</div>
